import { useContext, useEffect, useState } from "react";
import { hideModal } from "../../../context/Actions/modal/modal";
import { hideSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import { wsCambioEstadoVideoLlamada, wsGetTurnosPaciente } from "../../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../../context/Provider";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./SalirDeEspera.css";

const SalirDeEspera = ({ titulo, dissmiss, idturno }) => {
  const { turnosPacienteDispatch, modalDispatch, segundoModalDispatch } =
    useContext(PortalContext);
  const [estadoAgendado, setEstadoAgendado] = useState({
    id: idturno,
    estado: "P",
  });

  const salirDeFila = () => {
    wsCambioEstadoVideoLlamada(idturno, estadoAgendado)(turnosPacienteDispatch);
    hideModal()(modalDispatch);
    hideSegundoModal()(segundoModalDispatch);
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={true} />
      <div className="ptur-salirDeEspera-body">
        <p className="ptur-salirDeEspera-txt rb18l">
          ¿Desea salir de la fila de espera virtual?
        </p>
        <div className="ptur-salirDeEspera-btn">
          <button
            className="ptur-salirDeEspera-btnNoSalir bgc-white c-latex30 rb16m"
            onClick={dissmiss}
          >
            No
          </button>
          <button
            className="ptur-salirDeEspera-btnSalirDeFila bgc-primary c-white rb16m"
            onClick={salirDeFila}
          >
            Salir de la Espera
          </button>
        </div>
      </div>
    </>
  );
};

export default SalirDeEspera;
